import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary,
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: `1px solid ${theme.palette.info.light}`,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.info.light}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.info.dark,
  },
  checked: {},
}))(Switch);

const SwitchForm = React.forwardRef((props, ref) => {
  const { checked, onChange, name } = props;
  return (
    <div>
      <AntSwitch
        checked={checked || false}
        onChange={onChange}
        name={name}
        ref={ref}
        {...props}
      />
    </div>
      
  );
});

export default SwitchForm;